import { render, staticRenderFns } from "./question-boolean.vue?vue&type=template&id=24dac159&scoped=true"
import script from "./question-boolean.vue?vue&type=script&lang=js"
export * from "./question-boolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dac159",
  null
  
)

export default component.exports